import { Parent } from "../character.types";

// Import svih mama
import hannah from "../assets/images/parents/hannah.png";
import audrey from "../assets/images/parents/audrey.png";
import jasmine from "../assets/images/parents/jasmine.png";
import giselle from "../assets/images/parents/giselle.png";
import amelia from "../assets/images/parents/amelia.png";
import isabella from "../assets/images/parents/isabella.png";
import zoe from "../assets/images/parents/zoe.png";
import ava from "../assets/images/parents/ava.png";
import camilla from "../assets/images/parents/camilla.png";
import ashley from "../assets/images/parents/ashley.png";
import violet from "../assets/images/parents/violet.png";
import eveline from "../assets/images/parents/eveline.png";
import grace from "../assets/images/parents/grace.png";
import nicole from "../assets/images/parents/nicole.png";
import sophia from "../assets/images/parents/sophia.png";
import brianna from "../assets/images/parents/brianna.png";
import misty from "../assets/images/parents/misty.png";
import charlotte from "../assets/images/parents/charlotte.png";
import natalie from "../assets/images/parents/natalie.png";
import elizabeth from "../assets/images/parents/elizabeth.png";
import olivia from "../assets/images/parents/olivia.png";
import emma from "../assets/images/parents/emma.png";

// Import svih tata
import andrew from "../assets/images/parents/andrew.png";
import benjamin from "../assets/images/parents/benjamin.png";
import daniel from "../assets/images/parents/daniel.png";
import joshua from "../assets/images/parents/joshua.png";
import noah from "../assets/images/parents/noah.png";
import alex from "../assets/images/parents/alex.png";
import ethan from "../assets/images/parents/ethan.png";
import evan from "../assets/images/parents/evan.png";
import isaac from "../assets/images/parents/isaac.png";
import joan from "../assets/images/parents/joan.png";
import vincent from "../assets/images/parents/vincent.png";
import adrian from "../assets/images/parents/adrian.png";
import angel from "../assets/images/parents/angel.png";
import diego from "../assets/images/parents/diego.png";
import gabriel from "../assets/images/parents/gabriel.png";
import michael from "../assets/images/parents/michael.png";
import santiago from "../assets/images/parents/santiago.png";
import anthony from "../assets/images/parents/anthony.png";
import claude from "../assets/images/parents/claude.png";
import john from "../assets/images/parents/john.png";
import kevin from "../assets/images/parents/kevin.png";
import louis from "../assets/images/parents/louis.png";
import niko from "../assets/images/parents/niko.png";
import samuel from "../assets/images/parents/samuel.png";

// MOMS array
export const MOMS: Parent[] = [
  { name: "Hannah", value: "hannah", imageSrc: hannah },
  { name: "Audrey", value: "audrey", imageSrc: audrey },
  { name: "Jasmine", value: "jasmine", imageSrc: jasmine },
  { name: "Giselle", value: "giselle", imageSrc: giselle },
  { name: "Amelia", value: "amelia", imageSrc: amelia },
  { name: "Isabella", value: "isabella", imageSrc: isabella },
  { name: "Zoe", value: "zoe", imageSrc: zoe },
  { name: "Ava", value: "ava", imageSrc: ava },
  { name: "Camilla", value: "camilla", imageSrc: camilla },
  { name: "Ashley", value: "ashley", imageSrc: ashley },
  { name: "Violet", value: "violet", imageSrc: violet },
  { name: "Eveline", value: "eveline", imageSrc: eveline },
  { name: "Grace", value: "grace", imageSrc: grace },
  { name: "Nicole", value: "nicole", imageSrc: nicole },
  { name: "Sophia", value: "sophia", imageSrc: sophia },
  { name: "Brianna", value: "brianna", imageSrc: brianna },
  { name: "Misty", value: "misty", imageSrc: misty },
  { name: "Charlotte", value: "charlotte", imageSrc: charlotte },
  { name: "Natalie", value: "natalie", imageSrc: natalie },
  { name: "Elizabeth", value: "elizabeth", imageSrc: elizabeth },
  { name: "Olivia", value: "olivia", imageSrc: olivia },
  { name: "Emma", value: "emma", imageSrc: emma },
];

// FATHERS array
export const FATHERS: Parent[] = [
  { name: "Andrew", value: "andrew", imageSrc: andrew },
  { name: "Benjamin", value: "benjamin", imageSrc: benjamin },
  { name: "Daniel", value: "daniel", imageSrc: daniel },
  { name: "Joshua", value: "joshua", imageSrc: joshua },
  { name: "Noah", value: "noah", imageSrc: noah },
  { name: "Alex", value: "alex", imageSrc: alex },
  { name: "Ethan", value: "ethan", imageSrc: ethan },
  { name: "Evan", value: "evan", imageSrc: evan },
  { name: "Isaac", value: "isaac", imageSrc: isaac },
  { name: "Joan", value: "joan", imageSrc: joan },
  { name: "Vincent", value: "vincent", imageSrc: vincent },
  { name: "Adrian", value: "adrian", imageSrc: adrian },
  { name: "Angel", value: "angel", imageSrc: angel },
  { name: "Diego", value: "diego", imageSrc: diego },
  { name: "Gabriel", value: "gabriel", imageSrc: gabriel },
  { name: "Michael", value: "michael", imageSrc: michael },
  { name: "Santiago", value: "santiago", imageSrc: santiago },
  { name: "Anthony", value: "anthony", imageSrc: anthony },
  { name: "Claude", value: "claude", imageSrc: claude },
  { name: "John", value: "john", imageSrc: john },
  { name: "Kevin", value: "kevin", imageSrc: kevin },
  { name: "Louis", value: "louis", imageSrc: louis },
  { name: "Niko", value: "niko", imageSrc: niko },
  { name: "Samuel", value: "samuel", imageSrc: samuel },
];

// Default
export const DEFAULT_MOM = MOMS[0];
export const DEFAULT_FATHER = FATHERS[0];
